import { render, staticRenderFns } from "./ProductQtyList.vue?vue&type=template&id=180f61de&scoped=true"
import script from "./ProductQtyList.vue?vue&type=script&lang=js"
export * from "./ProductQtyList.vue?vue&type=script&lang=js"
import style0 from "./ProductQtyList.vue?vue&type=style&index=0&id=180f61de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f61de",
  null
  
)

export default component.exports